import { render, staticRenderFns } from "./AddResponsiblePerson.vue?vue&type=template&id=d66d006a&scoped=true"
import script from "./AddResponsiblePerson.vue?vue&type=script&lang=js"
export * from "./AddResponsiblePerson.vue?vue&type=script&lang=js"
import style0 from "./AddResponsiblePerson.vue?vue&type=style&index=0&id=d66d006a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66d006a",
  null
  
)

export default component.exports